import { useNavigate } from 'react-router-dom';
import { Clock, Trash2 } from 'lucide-react';
import { useApp } from '@/store/app';
import { TOOLS } from '@/registry';
import { ToolCard } from '@/components/ToolCard';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { formatRelativeTime } from '@/lib/utils';
import { CATEGORY_BY_ID } from '@/registry/categories';
import { cn } from '@/lib/cn';

export function RecentView() {
  const { recents, clearRecents } = useApp();
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="flex items-center gap-2">
            <Clock size={14} className="text-fg-subtle" />
            <h2 className="text-sm font-semibold uppercase tracking-wider text-fg-subtle">
              Recently used
            </h2>
          </div>
          <h1 className="text-3xl font-semibold tracking-tight mt-1">Pick up where you left off</h1>
        </div>
        {recents.length > 0 && (
          <Button variant="ghost" size="sm" onClick={clearRecents}>
            <Trash2 size={12} />
            Clear
          </Button>
        )}
      </div>

      {recents.length === 0 ? (
        <EmptyState
          icon={<Clock size={20} />}
          title="No recent tools"
          description="Tools you use will appear here for quick access."
          action={
            <Button variant="primary" onClick={() => navigate('/')}>
              Browse utilities
            </Button>
          }
        />
      ) : (
        <div className="space-y-2">
          {recents.map((r) => {
            const tool = TOOLS.find((t) => t.id === r.toolId);
            if (!tool) return null;
            const cat = CATEGORY_BY_ID[tool.category];
            const Icon = tool.icon;
            return (
              <button
                key={r.id}
                onClick={() => navigate(`/tool/${tool.id}`)}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg bg-surface border border-border hover:border-border-strong transition group"
              >
                <span
                  className={cn(
                    'size-9 rounded-lg flex items-center justify-center bg-gradient-to-br',
                    cat?.gradient,
                  )}
                >
                  <Icon size={14} className="text-white" />
                </span>
                <div className="flex-1 text-left min-w-0">
                  <div className="text-sm font-medium truncate">{tool.name}</div>
                  <div className="text-xs text-fg-muted truncate">{tool.description}</div>
                </div>
                <div className="text-xs text-fg-subtle font-mono shrink-0">{formatRelativeTime(r.ts)}</div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
